import React from 'react';
import ProxyTable from './Components/ProxyTable';

const index = () => <ProxyTable />;

export default index;
